import { action, Action } from "easy-peasy";

import { AppContextRole, Theme, Preferences } from "../types";

import { StoreMaker } from "./storeTypes";

export interface PreferencesStore extends Preferences {
  setRole: Action<PreferencesStore, AppContextRole>;
  setTheme: Action<PreferencesStore, Theme | undefined>;
}

const makePreferencesStore: StoreMaker<PreferencesStore> = (defaultValues) => ({
  role: defaultValues?.role ?? AppContextRole.Instructor,
  setRole: action((state, payload) => {
    state.role = payload;
  }),

  theme: defaultValues?.theme || "light",
  setTheme: action((state, payload) => {
    state.theme = payload;
  }),
});

export default makePreferencesStore;
